import {strEnum} from "../../types";
import {ITCIAppCustomizationParam} from "./tci-tenant-svcs";
import {TCITenantAppType} from "./tci-application";

/**
 * interface ITCIFile
 */
export interface ITCIFile {
    /**
     * File encoding
     */
    encoding: string;
    /**
     * File content
     */
    content: string | File | any;
    /**
     * File mime type
     */
    mimeType: string;
}

/**
 * interface ITCIFileMap
 */
export interface ITCIFileMap {
    /**
     *  File map
     */
    [fileName: string]: ITCIFile;
}

export const TCI_APP_MESSAGING = {
    TCI_TENANT_SVC_INIT_COMPLETE: "tenant-svc-init-complete"
};

export const TCI_ENV_VARS: string[] = [
    "WEBSERVER_RUN_MODE",
    // "WEB_SERVER_ENABLE_BACKEND_SERVICES",
    "TSC_HOME_PAGE_URL",
    "TSC_SIGNUP_URL",
    "VPN_ENABLED",
    "UPDATE_SITE",
    "EULA_URL",
    "ENVIRONMENT_TYPE",
    "TCI_DEPLOYMENT_NAME",
    "TCI_TENANT_ID",
    "SECURED_HTTP_PORT",
    "INDEX_URL",
    "REGISTER_URL",
    "WEB_SERVER_CORS_ALLOW_ORIGIN",
    "WEB_SERVER_SCRIBE_API_SERVICE",
    "WI_FLOGO_EDITION", // deprecated
    "DOMAIN_SERVICE",
    "DOMAIN_SERVICE_BACKEND",
    "WISTUDIO_SERVICE",
    "AO_SERVICE",
    "TA_SERVER_URL",
    "DEPLOY_INFO",
    "DEPLOY_CONFIG_VOLUME",
    "DISABLED_BUILD_LOGS",
    "TROPOSPHERE_NGINXAGENT_ELB_DNS",
    "TCI_DOCKER_DEPLOYMENT",
    "WI_FLOGO_ENTERPRISE", // deprecated
    "WEB_SERVER_DATE_TIME_FORMAT",
    "WEB_SERVER_SCRIBE_REQUEST_CONNECTOR_URL",
    "PUBLIC_TCI_DOMAIN_NAME",
    "METRIC_SERVER_COUNT",
    "ENABLE_TSC_INTEGRATION",
    "AZURE_CONNECTION",
    "PRODUCT_VERSION",
    "APP_VERSION",
    "TCI_MARKETPLACE_PROGRAM_GUIDE",
    "TCI_LOG_LIMIT_UI",
    "TCI_LOG_LIMIT_DOWNLOAD",
    "TCI_LOG_DOWNLOAD_SIZE_LIMIT",
    "TCI_LOG_DOWNLOAD_FETCH_SIZE",
    "IS_CIC2_ENV",
    "GET_TSC_ORGS_CONCURRENT",
    "GET_TSC_ORGS_PAGE_SIZE",
];
/**
 * TCI_ENVIRONMENT_VAR_TYPE is the allowed list of env vars used on Front End
 * @type {{[K in string]: K}}
 */
export const TCI_ENVIRONMENT_VAR_TYPE = strEnum(TCI_ENV_VARS);
export type TCI_ENVIRONMENT_VAR_TYPE = keyof typeof TCI_ENVIRONMENT_VAR_TYPE;

export interface ITCIProductVersion {
    productVersion: string;
}

export interface ITCIEnvVars<T> {
    [name: string]: T;
}

export interface ITCITimeZone {
    defaultTimezone: string;
}

export interface IModuleConfig {
    name: string;
    mode: string;
    type: string;
    jsResources: string[];
    htmlFiles: string[];
    cssFile: string[];
    langFile: string[];
    systemjs: any;
    customization?: { [id: string]: ITCIAppCustomizationParam };
}

export interface IService {
    name: string;
    healthCheckPath?: string;
    url?: string | boolean;
    id?: string;
    enabled?: boolean;
    time?: number;
    size?: number;
    isDockerDeployment?: boolean;
    isDockerDeployable?: boolean;
    isNg2: boolean;
    isTciTenant: boolean;
    isLocalTenant?: boolean;
    moduleConfig?: IModuleConfig;
}

export const UI_SERVICE_NAMES = strEnum(["bw", "node", "ucs", "scribe", "webserver", "wistudio", "liveapps"]);

export function mapIServiceToTenantAppType(svc: IService): TCITenantAppType {
    switch (svc.name) {
        case UI_SERVICE_NAMES.scribe:
            return TCITenantAppType.scribe;
        case UI_SERVICE_NAMES.bw:
            return TCITenantAppType.bw;
        case UI_SERVICE_NAMES.ucs:
            return TCITenantAppType.ucs;
        case UI_SERVICE_NAMES.wistudio:
            return TCITenantAppType.flogo;
        case UI_SERVICE_NAMES.node:
            return TCITenantAppType.node;
        case UI_SERVICE_NAMES.webserver:
            return TCITenantAppType.node;
        case UI_SERVICE_NAMES.liveapps:
            return TCITenantAppType.liveapps;
        default:
            throw new Error("Unknown tenant IService type:" + svc.name);
    }
}
